import axios from "axios";
import { getLoginTokens, setLoginTokens } from "./storageService";
import { forceLogout, refreshAccessToken } from "../utils/authHelpers";
import { API_BASE_URL } from "../config";

// Create an Axios instance
const api = axios.create({
	baseURL: API_BASE_URL,
	headers: {
		"Content-Type": "application/json",
	},
});

// Attach access token to requests
api.interceptors.request.use(
	(config) => {
		const { jawab_token } = getLoginTokens();
		if (jawab_token) {
			config.headers.Authorization = `Bearer ${jawab_token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

// Token refresh logic
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
	failedQueue.forEach((prom) => {
		if (error) {
			prom.reject(error);
		} else {
			prom.resolve(token);
		}
	});
	failedQueue = [];
};

// Handle 401 errors and refresh token
api.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config;

		if (error.response?.status === 401 && !originalRequest._retry) {
			originalRequest._retry = true;

			if (isRefreshing) {
				return new Promise((resolve, reject) => {
					failedQueue.push({ resolve, reject });
				})
					.then((token) => {
						originalRequest.headers.Authorization = "Bearer " + token;
						return api(originalRequest);
					})
					.catch((err) => Promise.reject(err));
			}

			isRefreshing = true;

			try {
				const success = await refreshAccessToken(API_BASE_URL);
				isRefreshing = false;

				if (success) {
					const { jawab_token } = getLoginTokens();
					processQueue(null, jawab_token);
					originalRequest.headers.Authorization = "Bearer " + jawab_token;
					return api(originalRequest);
				} else {
					processQueue("Refresh failed", null);
					forceLogout();
					return
				}
			} catch (err) {
				isRefreshing = false;
				processQueue(err, null);
				forceLogout();
				return;
			}
		}

		return Promise.reject(error);
	}
);

export default api;
